"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FilterType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function cov_b99xuxzip() {
  var path = "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/type.js";
  var hash = "e80595c57358a0e7f1bbf6c5f55e365a5c61488b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3193688389/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/filter/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 26
        },
        end: {
          line: 11,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e80595c57358a0e7f1bbf6c5f55e365a5c61488b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_b99xuxzip = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_b99xuxzip();
var FilterType = exports.FilterType = (cov_b99xuxzip().s[0]++, _propTypes.default.shape({
  minPrice: _propTypes.default.number,
  maxPrice: _propTypes.default.number,
  date: _propTypes.default.string,
  fromDate: _propTypes.default.string,
  toDate: _propTypes.default.string,
  selectedSite: _propTypes.default.array,
  selectedTeam: _propTypes.default.array
}));
var _default = exports.default = FilterType;